export type SeriesType = keyof typeof SeriesTypeEnum | string;

export enum SeriesTypeEnum {
  area = 'area',
  line = 'line',
  bar = 'bar',
  rangeColumn = 'rangeColumn',
  rangeArea = 'rangeArea',
  dot = 'dot',
  geo = 'geo',
  link = 'link',
  map = 'map',
  pie = 'pie',
  radar = 'radar',
  rose = 'rose',
  scatter = 'scatter',
  circularProgress = 'circularProgress',
  wordCloud = 'wordCloud',
  funnel = 'funnel',
  linearProgress = 'linearProgress',
  boxPlot = 'boxPlot',
  sankey = 'sankey',
  gaugePointer = 'gaugePointer',
  gauge = 'gauge',
  treemap = 'treemap',
  sunburst = 'sunburst',
  circlePacking = 'circlePacking',
  waterfall = 'waterfall',
  heatmap = 'heatmap',
  correlation = 'correlation',
  liquid = 'liquid',
  venn = 'venn',
  mosaic = 'mosaic',
  pictogram = 'pictogram'
}

export const enum SeriesMarkNameEnum {
  label = 'label',
  point = 'point',
  line = 'line',
  area = 'area',
  bar = 'bar',
  boxPlot = 'boxPlot',
  outlier = 'outlier',
  circlePacking = 'circlePacking',
  group = 'group',
  gridBackground = 'gridBackground',
  grid = 'grid',
  dot = 'dot',
  title = 'title',
  subTitle = 'subTitle',
  symbol = 'symbol',
  funnel = 'funnel',
  transform = 'transform',
  transformLabel = 'transformLabel',
  outerLabel = 'outerLabel',
  outerLabelLine = 'outerLabelLine',
  pin = 'pin',
  pinBackground = 'pinBackground',
  pointer = 'pointer',
  segment = 'segment',
  track = 'track',
  cell = 'cell',
  cellBackground = 'cellBackground',
  link = 'link',
  arrow = 'arrow',
  pie = 'pie',
  labelLine = 'labelLine',
  progress = 'progress',
  minLabel = 'minLabel',
  maxLabel = 'maxLabel',
  rose = 'rose',
  node = 'node',
  sunburst = 'sunburst',
  nonLeaf = 'nonLeaf',
  leaf = 'leaf',
  nonLeafLabel = 'nonLeafLabel',
  leaderLine = 'leaderLine',
  stackLabel = 'stackLabel',
  word = 'word',
  fillingWord = 'fillingWord',
  wordMask = 'wordMask',
  nodePoint = 'nodePoint',
  ripplePoint = 'ripplePoint',
  centerPoint = 'centerPoint',
  centerLabel = 'centerLabel',
  barBackground = 'barBackground',
  lineLabel = 'lineLabel',
  areaLabel = 'areaLabel',
  liquidGroup = 'liquidGroup',
  liquid = 'liquid',
  liquidBackground = 'liquidBackground',
  liquidOutline = 'liquidOutline',
  circle = 'circle',
  overlap = 'overlap',
  overlapLabel = 'overlapLabel'
}
